import { createFileRoute, Link } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { TaskViews } from '../../components/tasks/TaskViews.tsx'
import { openTask } from '../../lib/ui-state.ts'

export const Route = createFileRoute('/_app/tasks')({
  // ?task=<id> opens the task (links from MCP results and the chat)
  validateSearch: (s: Record<string, unknown>): { task?: string } =>
    typeof s.task === 'string' ? { task: s.task } : {},
  component: TasksPage,
})

function TasksPage() {
  const { t } = useTranslation()
  const { task } = Route.useSearch()
  useEffect(() => {
    if (task) openTask(task)
  }, [task])
  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-4 md:px-8 md:py-6">
        <header data-tauri-drag-region className="flex items-center gap-3">
          <h1 className="flex-1 text-[22px] text-text-1">{t('nav.tasks')}</h1>
          <Link to="/zusagen" className="font-medium text-[13px] text-pop-fg">
            {t('nav.commitments')}
          </Link>
        </header>
        <TaskViews />
      </div>
    </div>
  )
}
